export * from './src/multilingual-locales-v2-locale-locales.universal.js';
